export default "__VITE_ASSET__DfSyN8ob__"